import { ButtonMobile, Container, ListPlan } from './styles'
import { Step, useMenu } from '../../../contexts/MenuContext'
import Constants from '../../../assets/constants/constantsCategory'
import { Plan } from '../Plan'
import { PlanButton } from '../../molecules/PlanButton'
import PropTypes from 'prop-types'
import React from 'react'
import { Typography } from '@taglivros/tag-components'
import { navigate } from 'gatsby'
import { useCategory } from '../../../contexts/CategoryContext'

export function PlansOptions( { gifts } ) {
  const { setActivePlan, findPlanById, activeCategory, activeCategoryId, activePlanId, setActivePlanId, plans, findCategoryById } = useCategory()
  const { goToNextStep, activeStep } = useMenu()

  const handlePlanButtonClick = ( planId ) => {
    setActivePlanId( planId )
    setActivePlan( findPlanById( activeCategory, planId ) )
    navigate( '/associe-se/identificacao/' )

    if ( activeStep < Step.PERSONAL ) {
      goToNextStep( { 'activeStep': Step.CHOOSE_BOX } )
    }
  }

  const handlePlanClick = ( plan ) => {
    setActivePlan( plan )
    setActivePlanId( plan.id )
  }

  const color = activeCategoryId === 1 ? '#21C5E5' : '#FF9E16'

  return (
    <Container>
      <Typography
        as="h2"
        color="cinza500"
        fontWeight="l"
        variant="heading1"
      >
        Selecione um plano
      </Typography>

      <ListPlan>
        {plans[ activeCategoryId - 1 ].map( plan => {
          return (
            <Plan
              activeBox={ plan.id === 3 || plan.id === 6 }
              categorySelected={ activeCategoryId }
              color={ color }
              handlePlanClick={ handlePlanClick }
              isSelected={ plan.id === activePlanId }
              key={ plan.id }
              planObject={ plan }
              planSelected={ activePlanId }
              gifts={ gifts }
            />
          )
        } )}
      </ListPlan>
      <ButtonMobile>
        <PlanButton
          categorySelected={ activeCategoryId }
          color={ color }
          handlePlanClick={ handlePlanButtonClick }
          mobile
          planId={ activePlanId }
          titlePlan="Continuar"
        />
      </ButtonMobile>
    </Container>
  )
}

Plan.propTypes = {
  'color': PropTypes.string.isRequired,
}
